const CollectionPage = {
  init: async function () {
    if (!document.body.classList.contains('template-collection')) {
      return;
    }

    this.updateFreeShippingFilterVisibility();
    this.observeUrlChanges();
    this.observeFilterChanges();
    this.observeAjaxFilterChanges();
  },

  updateFreeShippingFilterVisibility: function () {
    const urlParams = new URLSearchParams(window.location.search);
    const hasPriceFilter = urlParams.has('filter.v.price.gte');
    this.updateFilterVisibility('.thb-filter-price-free-shipping-desktop', hasPriceFilter, 'desktop');
    this.updateFilterVisibility('.thb-filter-price-free-shipping-mobile', hasPriceFilter, 'mobile');
  },

  updateFilterVisibility: function (selector, hide, type) {
    const filter = document.querySelector(selector);
    if (!filter) {
      console.log(`Filtro ${type} no encontrado`);
      return;
    }

    if (hide) {
      filter.style.display = 'none';
      filter.setAttribute('data-hidden', 'true');
    } else {
      console.log(`Mostrando filtro de envío gratis (${type})`);
      filter.style.display = '';
      filter.removeAttribute('data-hidden');
    }
  },

  observeUrlChanges: function () {
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        this.updateFreeShippingFilterVisibility();
      }
    }).observe(document, { subtree: true, childList: true });
  },

  observeFilterChanges: function () {
    console.log('Configurando observador de cambios en los filtros');
    const filterContainer = document.querySelector('.thb-filter-container');
    if (filterContainer) {
      const observer = new MutationObserver((mutations) => {
        this.updateFreeShippingFilterVisibility();
      });
      observer.observe(filterContainer, { childList: true, subtree: true });
    } else {
      console.log('No se encontró el contenedor de filtros');
    }
  },

  observeAjaxFilterChanges: function () {
    document.addEventListener('click', (event) => {
      const clickedFilter = event.target.closest('.thb-filter-price-free-shipping-desktop, .thb-filter-price-free-shipping-mobile');

      if (clickedFilter) {
        this.handleFilterClick();
      }
    });
  },

  handleFilterClick: function () {
    const checkAndUpdateFilters = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const hasPriceFilter = urlParams.has('filter.v.price.gte');

      this.updateFreeShippingFilterVisibility();

      if (hasPriceFilter) {
        clearInterval(checkInterval);
      }
    };

    // Comprobar inmediatamente
    checkAndUpdateFilters();

    // Continuar comprobando cada 100ms durante 2 segundos
    const checkInterval = setInterval(checkAndUpdateFilters, 100);
    setTimeout(() => clearInterval(checkInterval), 2000);
  },
};

// Inicializar la página de colección cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function () {
  CollectionPage.init();
});

function sleep(ms) {
  console.log(`sleep ${ms}`);
  return new Promise(resolve => setTimeout(resolve, ms));
}

// Asegurarse de que se actualice la visibilidad después de que la página se haya cargado completamente
window.addEventListener('load', function () {
  if (document.body.classList.contains('template-collection')) {
    CollectionPage.updateFreeShippingFilterVisibility();
  }
});

// Añadir un listener para el evento AJAX de Shopify
document.addEventListener('shopify:section:load', async function (event) {
  if (document.body.classList.contains('template-collection')) {

    console.log("price update");
    //Dormimos la ejecución durante 3 segundos
    await sleep(10000);
    CollectionPage.updateFreeShippingFilterVisibility();
  }
});

// Mobile: asegurar que solo haya un Search-Drawer y que esté correctamente posicionado
(function () {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  if (!isMobile) return;
  const nativeSearchDisabled = document.getElementById('Search-Drawer')?.dataset.nativeSearchDisabled === 'true';
  if (nativeSearchDisabled) return;

  function ensureSingleSearchDrawer() {
    // Verificar si hay múltiples Search-Drawers y eliminar duplicados
    const searchDrawers = document.querySelectorAll('#Search-Drawer');
    if (searchDrawers.length > 1) {
      // Mantener solo el primero y eliminar los demás
      for (let i = 1; i < searchDrawers.length; i++) {
        searchDrawers[i].remove();
      }
    }
    
    const searchDrawer = document.getElementById('Search-Drawer');
    if (!searchDrawer) return;
    
    // Asegurar que esté dentro del theme-header, no fuera
    const header = document.querySelector('theme-header#header');
    if (header && !header.contains(searchDrawer)) {
      header.appendChild(searchDrawer);
    }
    
    // Aplicar estilos solo si no están ya aplicados
    if (!searchDrawer.classList.contains('active')) {
      searchDrawer.classList.add('active');
    }
    if (searchDrawer.style.transform !== 'none') {
      searchDrawer.style.transform = 'none';
      searchDrawer.style.opacity = '1';
      searchDrawer.style.visibility = 'visible';
      searchDrawer.style.display = 'block';
      searchDrawer.style.transition = 'none';
    }
  }

  // Ejecutar inmediatamente si el elemento ya existe
  if (document.getElementById('Search-Drawer')) {
    ensureSingleSearchDrawer();
  }

  // También ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureSingleSearchDrawer);
  } else {
    ensureSingleSearchDrawer();
  }
  
  // Observar cambios en el DOM para detectar duplicaciones
  const observer = new MutationObserver(() => {
    const searchDrawers = document.querySelectorAll('#Search-Drawer');
    if (searchDrawers.length > 1) {
      ensureSingleSearchDrawer();
    }
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
})();

// Buscador de escritorio: predictive search en el input (sin abrir drawer)
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 1068px)').matches;
  }
  function setup() {
    if (!isDesktop()) {
      // En mobile, asegurar que no haya duplicados del desktop search
      const desktopSearchContainer = document.querySelector('[data-desktop-search]');
      if (desktopSearchContainer) {
        const desktopInput = desktopSearchContainer.querySelector('.thb-desktop-search__input');
        if (desktopInput) {
          // Remover event listeners si existen
          desktopInput.replaceWith(desktopInput.cloneNode(true));
        }
      }
      return;
    }
    const container = document.querySelector('[data-desktop-search]');
    if (!container) return;
    const nativeSearchDisabled = container.dataset.nativeSearchDisabled === 'true';
    if (nativeSearchDisabled) return;
    const input = container.querySelector('.thb-desktop-search__input');
    const form = container.querySelector('.thb-desktop-search__form');
    const results = container.querySelector('.thb-desktop-search__results');

    const debounce = (fn, delay = 300) => {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); };
    };

    function hideResults() {
      if (results) results.setAttribute('hidden', '');
    }
    function showResults() {
      if (results) results.removeAttribute('hidden');
    }
    function showRecommended() {
      // El drawer está oculto en desktop pero su contenido sigue siendo accesible
      const initial = document.querySelector('#Search-Drawer .side-panel-content--initial');
      if (initial && results) {
        results.innerHTML = `<div class="side-panel-content--initial">${initial.innerHTML}</div>`;
        showResults();
      }
    }
    function getQuery() {
      return (input?.value || '').trim();
    }
    function fetchResults(term) {
      if (!term) { hideResults(); return; }
      fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(term)}&${encodeURIComponent('resources[type]')}=product,article,query&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search');
          if (!html) { hideResults(); return; }
          results.innerHTML = html.innerHTML;
          // Ajustar textos de botones dentro del dropdown
          results.querySelectorAll('.product-card--add-to-cart-text').forEach((el) => {
            el.textContent = 'Ver más..';
          });
          // En desktop, el HTML inyectado incluye un botón con id #search-results-submit
          // que en el drawer móvil dispara un submit mediante predictive-search.js.
          // Aquí debemos re-vincularlo al formulario de escritorio.
          const viewAllBtn = results.querySelector('#search-results-submit');
          if (viewAllBtn) {
            viewAllBtn.addEventListener('click', (e) => {
              e.preventDefault();
              if (form) {
                form.submit();
              }
            });
          }
          showResults();
        })
        .catch(() => { });
    }

    if (input) {
      // Al escribir: mostrar resultados predictivos
      input.addEventListener('input', debounce(() => {
        const q = getQuery();
        if (q) {
          fetchResults(q);
        } else {
          hideResults();
        }
      }, 300));
      // Al hacer clic: si hay texto, mostrar resultados; si no, mostrar recomendaciones
      input.addEventListener('click', () => {
        const q = getQuery();
        if (q) {
          fetchResults(q);
        } else {
          showRecommended();
        }
      });
      // Al recibir foco: igual que click (solo cuando el usuario interactúa)
      input.addEventListener('focus', () => {
        const q = getQuery();
        if (q) {
          fetchResults(q);
        } else {
          showRecommended();
        }
      });
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { hideResults(); input.blur(); }
      });
    }
    if (form) {
      form.addEventListener('submit', (e) => {
        if (!getQuery()) e.preventDefault();
      });
    }
    document.addEventListener('click', (e) => {
      if (!container.contains(e.target)) hideResults();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  window.addEventListener('resize', setup);
})();

(function () {
  const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)';
  const CTA_SELECTOR = '#Search-Drawer .side-panel-content--initial .product-card--add-to-cart-text';
  const desktopQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);

  function updateSelectedForYouCtas() {
    const isDesktop = desktopQuery.matches;
    document.querySelectorAll(CTA_SELECTOR).forEach((el) => {
      const original = el.dataset.originalText || el.textContent.trim();
      if (!el.dataset.originalText) {
        el.dataset.originalText = original;
      }
      el.textContent = isDesktop ? 'Ver más' : el.dataset.originalText;
    });
  }

  function initSelectedForYouCtas() {
    updateSelectedForYouCtas();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelectedForYouCtas);
  } else {
    initSelectedForYouCtas();
  }

  document.addEventListener('shopify:section:load', initSelectedForYouCtas);
  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', updateSelectedForYouCtas);
  } else if (desktopQuery.addListener) {
    desktopQuery.addListener(updateSelectedForYouCtas);
  }
})();

// Corregir badges que muestran "Productos" en lugar del porcentaje de descuento
(function() {
  function updateBadges() {
    const badges = document.querySelectorAll('.thb-predictive-search--promotion-products .badge.onsale, .thb-desktop-search__results .badge.onsale');
    badges.forEach(badge => {
      if (badge.textContent.trim() === 'Productos' || badge.textContent.trim().includes('Productos')) {
        const productCard = badge.closest('product-card');
        if (!productCard) return;
        
        const productLink = productCard.querySelector('a[href*="/products/"]');
        if (!productLink) return;
        
        const productHandle = productLink.href.match(/\/products\/([^\/\?]+)/)?.[1];
        if (!productHandle) return;
        
        fetch(`/products/${productHandle}.js`)
          .then(response => response.json())
          .then(product => {
            const salePrice = Number(product.price);
            let compareAt = product.compare_at_price != null ? Number(product.compare_at_price) : null;
            if (product.variants && product.variants.length && Number.isFinite(salePrice)) {
              const minVariant = product.variants.find((v) => Number(v.price) === salePrice);
              if (minVariant && minVariant.compare_at_price != null) {
                compareAt = Number(minVariant.compare_at_price);
              }
            }
            if (compareAt && salePrice && compareAt > salePrice) {
              const discountPercentage = Math.round(((compareAt - salePrice) / compareAt) * 100);
              badge.textContent = `${discountPercentage}% OFF`;
            }
          })
          .catch(() => {});
      }
    });
  }

  const observer = new MutationObserver(() => {
    updateBadges();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateBadges();
      observer.observe(document.body, { childList: true, subtree: true });
    });
  } else {
    updateBadges();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

